let parseUrl = function(url) {
    let index;
    let scheme;
    let host;
    let path;
    let query;
    let hash;

    index = url.indexOf('#');
    if (index != -1) {
        hash = url.substr(index + 1);
        url = url.substr(0, index);
    }
    else {
        hash = '';
    }

    index = url.indexOf('?');
    if (index != -1) {
        query = url.substr(index + 1);
        url = url.substr(0, index);
    }
    else {
        query = '';
    }

    index = url.indexOf(':');
    if (index == -1) {
        scheme = "";
    }
    else {
        scheme = url.substr(0, index);
        url = url.substr(index + 3);
    }

    index = url.indexOf('/');
    if (index == -1) {
        host = url;
        path = "/";
    }
    else {
        host = url.substr(0, index);
        path = url.substr(index);
    }

    if (!path) {
        path = '/';
    }

    if (query) {
        let arr = query.split('&');
        let q = {};
        for (let i = 0;i < arr.length; i++) {
            let sub = arr[i].split('=');
            q[sub[0]] = decodeURIComponent(sub[1]);
        }
        query = q;
    }
    else {
        query = {};
    }

    return {
        scheme,
        host,
        path,
        hash,
        query
    };
};

export default parseUrl